import { createPageSchema as e, opaqueCursorSchema as t, pageLimitSchema as n, uuidSchema as r } from "../common/index.js";
import { z as i } from "zod";
// src/customers/core.ts
var a = 100;
function o(e) {
	return e.normalize("NFC").trim().toLocaleLowerCase("und");
}
var s = i.string().transform((e) => e.normalize("NFC").trim()).pipe(i.string().refine((e) => [...e].length >= 1 && [...e].length <= 100, "Customer name must contain 1–100 Unicode code points.")), c = i.enum(["active", "archived"]), l = i.number().int().positive(), u = i.string().min(16).max(128), d = i.object({
	id: r,
	name: s,
	status: c,
	version: l,
	createdAt: i.string().datetime({ offset: !0 }),
	updatedAt: i.string().datetime({ offset: !0 }),
	archivedAt: i.string().datetime({ offset: !0 }).nullable()
}).strict(), f = d.extend({
	assignmentCount: i.number().int().nonnegative(),
	knownNumberCount: i.number().int().nonnegative()
}), p = i.object({
	query: i.string().trim().max(100).optional(),
	status: c.default("active"),
	cursor: t.optional(),
	limit: n
}).strip(), m = e(d), h = i.enum([
	"CAPABILITY_DENIED",
	"INVALID_REQUEST",
	"CUSTOMER_NAME_EXISTS",
	"CLIENT_CODE_EXHAUSTED",
	"ASSIGNMENT_EXISTS",
	"TEAM_INACTIVE",
	"KNOWN_NUMBER_EXISTS",
	"INVALID_PHONE_NUMBER",
	"IDEMPOTENCY_CONFLICT",
	"CUSTOMER_ARCHIVED",
	"VERSION_CONFLICT",
	"DEPENDENCY_UNAVAILABLE",
	"CUSTOMER_AUDIT_POLICY_UNAVAILABLE",
	"NOT_FOUND"
]), g = i.object({
	code: h,
	message: i.enum([
		"Customer management is not permitted.",
		"Customer request is invalid.",
		"Customer name is already reserved.",
		"No customer identification codes are available.",
		"Team is already assigned to this customer.",
		"Team must be active for assignment.",
		"Number is already registered.",
		"Enter a complete international number beginning with +.",
		"Idempotency key was already used for another request.",
		"Archived customer cannot be changed.",
		"Customer has changed; reload before retrying.",
		"Customer dependency is unavailable.",
		"Customer business audit is unavailable.",
		"Customer was not found."
	]),
	correlationId: r
}).strict();
export { a as CUSTOMER_NAME_MAX_CODE_POINTS, f as customerDetailSchema, h as customerErrorCodeSchema, g as customerErrorSchema, u as customerIdempotencyKeySchema, p as customerListQuerySchema, s as customerNameSchema, m as customerPageSchema, c as customerStatusSchema, d as customerSummarySchema, l as customerVersionSchema, o as normalizeCustomerName };

//# sourceMappingURL=core.js.map